import { render, staticRenderFns } from "./WaitingApprove.vue?vue&type=template&id=2f8812f8&scoped=true&"
import script from "./WaitingApprove.vue?vue&type=script&lang=js&"
export * from "./WaitingApprove.vue?vue&type=script&lang=js&"
import style0 from "./WaitingApprove.vue?vue&type=style&index=0&id=2f8812f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8812f8",
  null
  
)

export default component.exports